import React from 'react';
import ReactDOM from 'react-dom';
import EditorContainer from './EditorContainer';

import './index.scss';

export default function Editor(props) {
    const {
        onClose, 
        onSave,
        imageUrl
    } = props
    return <EditorContainer onClose={onClose} onSave={onSave} imageUrl={imageUrl} />
}
